// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"68afae2b","384":"79da5aab","870":"916472a0"}[chunkId] + ".chunk.js";
};